import { atom, useAtom } from "jotai";

export const showOneClickTradingModalAtom = atom(false);

export const useShowOneClickTradingModal = () => {
  const [showOneClickTradingModal, setShowOneClickTradingModal] = useAtom(
    showOneClickTradingModalAtom,
  );

  return {
    showOneClickTradingModal,
    setShowOneClickTradingModal,
  };
};
